import { get } from 'lodash';
import { EMPTY_ARRAY } from '../../../constants/utils';

export const ids = state => get(state, 'account.messages.idmessages', EMPTY_ARRAY);
export const count = state => get(state, 'account.messages.count', 0);
export const perPage = state => get(state, 'account.messages.perPage', 20);
export const loading = state => get(state, 'account.messages.lodaing', false);
